"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theming = require("../../../../theming");

var _themeContants = require("../../../../constants/themeContants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Slider2Handle = function Slider2Handle(_ref) {
  var className = _ref.className,
      _ref$domain = _slicedToArray(_ref.domain, 2),
      min = _ref$domain[0],
      max = _ref$domain[1],
      _ref$handle = _ref.handle,
      id = _ref$handle.id,
      value = _ref$handle.value,
      percent = _ref$handle.percent,
      restProps = _objectWithoutProperties(_ref, ["className", "domain", "handle"]);

  return _react["default"].createElement(HandleButton, _extends({
    type: "button",
    role: "slider",
    className: className,
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": value,
    percent: percent
  }, restProps));
};

Slider2Handle.themeProps = {
  handle: {
    name: "SLIDER2_HANDLE",
    description: "Handle style",
    type: _themeContants.themePropTypes.style
  }
};

var HandleButton = _styledComponents["default"].button.withConfig({
  displayName: "Slider2Handle__HandleButton",
  componentId: "sc-1y0r10g-0"
})(["position:absolute;left:", "%;margin-left:-11px;margin-top:-6px;z-index:2;width:", ";height:", ";cursor:pointer;border:0;border-radius:50%;box-shadow:0px 2px 6px rgba(0,0,0,0.15);background-color:", ";border:1px solid ", ";transition:box-shadow 0.2s ease;&:focus,&:active,&:hover{outline:0;box-shadow:0px 2px 3px rgba(0,0,0,0.15);}", ";"], function (p) {
  return p.percent;
}, _theming.spacing.medium, _theming.spacing.medium, _theming.color.white, _theming.color.line, (0, _theming.applyVariants)(Slider2Handle.themeProps.handle));

Slider2Handle.defaultProps = {
  className: ""
};
Slider2Handle.propTypes = {
  className: _propTypes["default"].string,
  domain: _propTypes["default"].array.isRequired,
  handle: _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].number.isRequired,
    percent: _propTypes["default"].number.isRequired
  }).isRequired,
  getHandleProps: _propTypes["default"].func.isRequired
  /** @component */

};
var _default = Slider2Handle;
exports["default"] = _default;